import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { VisitAttributes } from '@albatrosdeveloper/ave-models-package';
import { BusinessPartnerNavigationComponent } from 'app/shared/components/business-partner-navigation/business-partner-navigation.component';
import { BusinessPartnerDisplayComponent } from 'app/shared/components/business-partner-display/business-partner-display.component';

/**
 * Business Partner Cell Renderer
 *
 * Renders business partner code (uppercase) and name on separate lines
 *
 * @example
 * ```typescript
 * {
 *   field: 'shipTo',
 *   headerName: 'Socio de Negocio',
 *   cellRenderer: BusinessPartnerCellRendererComponent,
 *   minWidth: 200
 * }
 * ```
 */
@Component({
  selector: "app-business-partner-cell-renderer",
  standalone: true,
  imports: [CommonModule, BusinessPartnerDisplayComponent],
  template: `
    <div class="leading-tight">
      <app-business-partner-display
        [shipTo]="params.data.shipTo"
        [showLabels]="false"
        [useSoldTo]="false"
      ></app-business-partner-display>
    </div>
  `,
})
export class BusinessPartnerCellRendererComponent
  implements CellRenderer<VisitAttributes>
{
  @Input() params!: CellRendererParams<VisitAttributes>;
}
